<template>
  <div class="wrapper">
    <div class="loading">
      <div class="loading-animation">
        <lottie :options="loadingDefault" />
      </div>
      <span class="loading-text">Loading...</span>
    </div>
  </div>
</template>

<script>
import lottie from "@/components/Lottie";
import * as loadingData from "@/assets/animations/loading/loading.json";

export default {
  data() {
    return {
      loadingDefault: { animationData: loadingData.default, loop: true }
    };
  },

  components: {
    lottie
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $zIndex + 999;
  background-color: #333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .loading {
    height: 100%;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 100px;

    .loading-animation {
      height: auto;
      width: 50%;
      max-width: 600px;
    }

    .loading-text {
      display: block;
      padding: 20px;
      font-size: 50px;
      margin-top: 20px;
      color: #666;

      @include mobile {
        padding: 0;
        font-size: 20px;
      }
    }
  }
}
</style>
